import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { ICONS_DUPLICATES } from 'assets/icons/icons-duplicates';

/**
 * Component for using icons in app
 */
@Component({
  selector: 'isp-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./scss/svg-icon.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent implements OnChanges {
  /** Icon name */
  @Input() name: string;

  /** Custom icon size */
  @Input() size: string;

  /** Custom icon width */
  @Input() width: string;

  /** Custom icon height */
  @Input() height: string;

  iconsStyle?: Partial<CSSStyleDeclaration>;

  mappedName: string;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  private updateIconsStyle(): void {
    const width = this.width || this.size;
    const height = this.height || this.size;
    if (width || height) {
      this.iconsStyle = {
        width,
        height,
      };
    } else {
      delete this.iconsStyle;
    }
    this.cdr.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.size || changes.height || changes.width) {
      this.updateIconsStyle();
    }

    if (changes.name) {
      this.mappedName = ICONS_DUPLICATES[this.name] || this.name;
    }
  }
}
